import FilterBox from "./filter-box";
import { FilterActiveValues, FilterActiveValue } from "./active-filters";
import FilterParamStats from "./filter-stats";

export default abstract class FilterBase {
    protected baseElement: HTMLElement;
    protected filterBox: FilterBox;
    protected pageId: number;
    private _paramId: number;

    get paramId() {
        return this._paramId;
    }

    constructor(element: HTMLElement, filterBox: FilterBox) {
        this.baseElement = element;
        this.filterBox = filterBox;
        this._paramId = this.getParamId();
        this.pageId = filterBox.pageId;

        this.addClearButtonHandler();
        this.filterBox.register(this);
    }

    private getParamId(): number {
        return Number(this.baseElement.getAttribute('data-param-id'));
    }

    private addClearButtonHandler() {
        this.baseElement.querySelector('.clear-link').addEventListener('click', () => this.clear());
    }

    abstract init(): void;

    public async setValues(values: string): Promise<void> {
        await this.setValuesInternal(values);
        
        this.updateSelectedValuesAttribute();
        this.updateActiveFilterValues();
    }
    
    protected abstract setValuesInternal(values: string): Promise<void>;

    protected clear(): void{
        this.clearValues();
        this.applyFilterChanges();
    }

    public clearValues(): void{
        this.clearValuesInternal();
        this.updateSelectedValuesAttribute();
    }

    protected abstract clearValuesInternal(): void;

    protected updateAttributeAndApplyChanges(): void {
        this.updateSelectedValuesAttribute();
        this.applyFilterChanges();
    }

    protected applyFilterChanges(){
        this.filterBox.refreshFiltersAndProducts();
        this.updateActiveFilterValues();
    }

    protected updateActiveFilterValues(){
        this.filterBox.setActiveFilterValues(new FilterActiveValues(this.paramId, this.getActiveFilterValues(), (value) => this.unselect(value)));
    }

    protected updateSelectedValuesAttribute(): void {
        const values = this.getSelectedValuesConcat();
        if(values) {
            this.baseElement.dataset.selectedValues = values;
        } else {
            delete this.baseElement.dataset.selectedValues;
        }
    }

    protected abstract getSelectedValuesConcat(): string;

    protected abstract getActiveFilterValues(): FilterActiveValue[];

    public abstract unselect(value: string): void;

    public setStats(stats: FilterParamStats): void {}

}
